import React, { useEffect, useState } from 'react';
import Poll from 'react-polls';
import { AppBar, Button, Grid, Tab, Tabs } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRoomContext } from '../../../../RoomContext';
import { useIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import * as toolareaActions from '../../../../store/actions/toolareaActions';
import '../styles.css';
import { makePermissionSelector, peersLengthSelector } from '../../../../store/selectors';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { permissions } from '../../../../permissions';
import DotSpinLoader from '../../../Loader/dotSpinLoader';
import CloseBtn from '../../closeBtn';
import GradientButton from '../../../customMui/newButton/newButton';
import axios from 'axios';
import { store } from '../../../../store/store';

const styles = (theme) =>
	({
		root :
		{
			display       : 'flex',
			flexDirection : 'column',
			padding       : '0.5rem 0'
		},
		flexInline :
		{
			display : 'inline-flex',
			flex    : 'none'
		},
		list :
		{
			listStyleType   : 'none',
			// boxShadow       : '0 2px 5px 2px rgba(0, 0, 0, 0.2)',
			backgroundColor : 'rgba(255, 255, 255, 1)'
		},
		listheader :
		{
			fontWeight : 'bolder'
		},
		pdngHSM :
		{
			padding : '0 0.75rem'
		},
		flexRow :
		{
			display : 'flex',
			flex    : 'none'
		},
		justifyBtwn :
		{
			justifyContent : 'space-between'
		},
		pdngSM :
		{
			padding : '0.75rem'
		},
		alignCntr :
		{
			alignItems : 'center'
		},
		brdrBSM :
		{
			borderBottom : '1px solid lightgrey'
		},
		flexCol :
		{
			display       : 'flex',
			flex          : 'none',
			flexDirection : 'column',
			width         : '100%'
		}
	});

const PollsResult = (props) =>
{
	// const customTheme = {
	// 	questionSeparator      : false,
	// 	questionSeparatorWidth : 'question',
	// 	questionBold           : false,
	// 	questionColor          : '#4F70D6',
	// 	align                  : 'center',
	// 	theme                  : 'blue'
	// };

	const {
		classes,
		currentResultPollObj,
		roomClient,
		peersLength,
		toggleToolArea,
		setToolTab,
		peersPollSubmitObj,
		pollSubmitList,
		isModerator,
		webinarUser,
		meetData,
		handleClose,
		setSideComp
	} = props;

	// const handleVote = () =>
	// {
	// };

	const [ pollResult, setPollResult ] = useState({});
	const [ totalVotes, setTotalVotes ] = useState(0);
	const [ resultPublished, setResultPublished ] = useState(false);
	const [ sessionDetails, setSessionDetails ] = useState(null);
	const [ isLoading, setIsLoading ] = useState(false);
	const colors = [ '#119000', '#F6C67A', '#73D8BE', '#6CA4F8', '#DFA688' ];

	useEffect(() =>
	{
		getPollResultData();
	}, []);

	async function getPollResultData()
	{
		setIsLoading(true);

		const meetingDetailsData = await roomClient.getMeetingInfo();

		setSessionDetails(meetingDetailsData?.meetingDetails);

		axios.get(`${import.meta.env.VITE_USERS}/getpollresults/${meetData?._id? meetData?._id : meetingDetailsData?.meetingDetails?.meetingId}/${meetData?.sessionId ? meetData?.sessionId : store.getState().room?.name}/${currentResultPollObj?._id}`)
			.then((response) =>
			{
				if (response.data.status)
				{
					pollSubmitList(currentResultPollObj?._id, response.data.data);
					if (response.data.data.isPublishResult)
					{
						setResultPublished(true);
					}
				}
				setIsLoading(false);
			})
			.catch((error) =>
			{
				// console.log('error in getting poll result::', error);
				toast.error(error?.response?.data?.err);
				setIsLoading(false);
			});
	}

	useEffect(() =>
	{
		const finalObj = peersPollSubmitObj[currentResultPollObj._id];

		setPollResult(finalObj);
		let total = 0;

		finalObj?.options?.forEach((element) =>
		{
			total += element.votes;
		});
		setTotalVotes(total);
	}, [ peersPollSubmitObj ]);

	const intl = useIntl();

	const handleBackToList = () =>
	{
		if (webinarUser)
		{
			setSideComp('poll');
		}
		else
		{
			setToolTab('polling');
		}
	};

	const handlePublishResult = async () =>
	{
		if (currentResultPollObj?.isStop)
		{
			if (resultPublished)
			{
				toast.error(intl.formatMessage({
					id             : 'pollResultAlreadyPublished',
					defaultMessage : 'Poll result already published!'
				}));
			}
			else
			{
				setIsLoading(true);
				axios.put(`${import.meta.env.VITE_USERS}/publishResult/${meetData?._id ? meetData?._id : sessionDetails?.meetingDetails?.meetingId}/${meetData?.sessionId? meetData?.sessionId : store.getState().room?.name}/${currentResultPollObj?._id}`)
					.then((response) =>
					{
						if (response.data.status)
						{
							toast.success(intl.formatMessage({
								id             : 'pollResultPublishedSuccess',
								defaultMessage : 'Poll result published successfully!'
							}));
							getPollResultData();
							roomClient.sendPolling({});
						}
						setIsLoading(false);

						roomClient.sendPeersPoolsubmitedObjToScreens(
							peersPollSubmitObj[currentResultPollObj._id]
						);
					})
					.catch((error) =>
					{
						// console.log('error in getting poll result::', error);
						toast.error(error?.response?.data?.err);
						setIsLoading(false);
					});
			}
		}
		else
		{
			toast.error(intl.formatMessage({
				id             : 'stopPollingBeforePublishing',
				defaultMessage : 'You need to stop polling to publish results'
			}));
		}
	};
	const closeDrawer = () =>
	{
		toggleToolArea();
	};

	const handleClearResult = () =>
	{
		roomClient.sendPeersPoolsubmitedObjToScreens(
			{}
		);
		setResultPublished(false);
	};

	return (
		<div className='flexCol fullH'>
			{/* <div className='flexInline pdngHSM brdrBSM'>
				<h2>
					<FormattedMessage
						id='label.result'
						defaultMessage='Result'
					/>
				</h2>
			</div> */}

			<div className='flexRow aCntr pdngSM'>
				{/* <img src='/icons/close.svg' alt='cancel' className='IconImage pointer' onClick={closeDrawer} /> */}
				{webinarUser ? <img src='icons/close.svg' alt='back' className='pointer' onClick={handleClose}/> : <CloseBtn/>}
				<div className='flexRow jCntr aCntr'>
					<span className=' cusRPdng mHdng'><b>{intl.formatMessage({
						id             : 'label.result',
						defaultMessage : 'Result'
					})
					}</b></span>
				</div>
			</div>
			{/* <Grid
				container spacing={3}
			>
				{questions?.map((each, index) => (
					<Grid key={index} item xs={12}>
						<Poll
							question={each?.question}
							answers={each?.options}
							onVote={handleVote}
							customStyles={customTheme}
							noStorage
						/>
					</Grid>
				))}
			</Grid> */}
			<div className='flexCol pBodyN pdngMD'>
				<span className='pdngHXS pdngVMD wordBreak ellipse brdrBSM'>{pollResult?.question}</span>
				<div className='flexMinWidthCol pdngVMD pollsHg '>
					{pollResult && pollResult.options && pollResult.options.map((each, index) => (
						<div key={index} className='flexCol pdngVMD'>
							<div className='flexRow barContainer'>
								<div className='flexRow'>
									<div className='flexMinWidthRow pdngXSM'>
										<span className='pollOption ellipse' >{each?.option} <span >({each?.votes}/{totalVotes} voted)</span></span>
									</div>
									<div className='flexAutoCol pdngXSM pollingPercentage'>
										<span className='pollOption ellipse'>{(each?.votes !== 0) ? (((each.votes/totalVotes) * 100) === Math.floor((each.votes/totalVotes) * 100) ? ((each.votes/totalVotes) * 100) : ((each.votes/totalVotes) * 100).toFixed(2)) : 0}%</span>
									</div>
								</div>
								<div className='bar' style={{ width: `${(each.votes/totalVotes) * 100 }%`, backgroundColor: `${colors[index]}` }} />
							</div>
						</div>
					))}
					<div className='flexRow'>
						<div className='flexMinWidthCol pdngXXS'>
							<span>
								<FormattedMessage
									id='label.totalVotes'
									defaultMessage='Total Votes'
								/>: {totalVotes}</span>
						</div>
						{/* <div className='flexAutoCol pdngSM'>
						<span><b>Percentage:</b> 100%</span>
					</div> */}
					</div>
				</div>
				{ resultPublished &&
				<div className='flexCol aCntr'>
					<span>
						<FormattedMessage
							id='label.resultPublished'
							defaultMessage='Result published'
						/></span>
				</div>
				}

				<div className='flexRow aEnd jEnd mrgnVSM gap16 pdngHXS '>
					<Button
						aria-label={intl.formatMessage({
							id             : 'label.backToList',
							defaultMessage : 'backToList'
						})}
						className={classes.button}
						variant='outlined'
						fullWidth
						size='small'

						disableElevation
						style={{ borderRadius: '10px' }}
						color='primary'
						onClick={() => handleBackToList()}
					>
						<FormattedMessage
							id='label.backToList'
							defaultMessage='Back to List'
						/>
					</Button>
					{isModerator && !resultPublished &&
					<GradientButton
						aria-label={intl.formatMessage({
							id             : 'label.publishResult',
							defaultMessage : 'publishResult'
						})}
						variant='contained'
						disableElevation
						fullWidth
						size='small'
						style={{ borderRadius: '10px' }}
						color='primary'
						onClick={() => handlePublishResult()}
					>
						<FormattedMessage
							id='label.publishResult'
							defaultMessage='Publish Result'
						/>
					</GradientButton>
					}
				</div>
			</div>
			{isLoading && <DotSpinLoader />}
			<ToastContainer
				position='top-right'
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnVisibilityChange
				draggable
				pauseOnHover
			/>
		</div>
	);
};

PollsResult.propTypes =
{
	roomClient           : PropTypes.object.isRequired,
	classes              : PropTypes.object.isRequired,
	currentResultPollObj : PropTypes.object,
	toggleToolArea       : PropTypes.func.isRequired,
	peersLength        	 : PropTypes.number,
	isModerator          : PropTypes.bool.isRequired,
	setToolTab           : PropTypes.func,
	peersPollSubmitObj   : PropTypes.object,
	pollSubmitList       : PropTypes.func,
	meetData             : PropTypes.any,
	webinarUser          : PropTypes.any,
	handleClose          : PropTypes.any,
	setSideComp          : PropTypes.func
};

const makeMapStateToProps = () =>
{
	const hasPermission = makePermissionSelector(permissions.MODERATE_ROOM);
	const mapStateToProps = (state) => ({
		me                   : state.me,
		settings             : state.settings,
		pollingTab           : state.toolarea,
		currentResultPollObj : state.toolarea.currentResultPollObj,
		peersLength          : peersLengthSelector(state),
		isModerator          : hasPermission(state),
		peersPollSubmitObj   : state.toolarea.peersPollSubmitObj,
		meetData             : state.webinar.webinarData

	});

	return mapStateToProps;

};

const mapDispatchToProps = (dispatch) => ({
	setToolTab : (tab) =>
		dispatch(toolareaActions.setToolTab(tab)),
	pollSubmitList : (id, data) => dispatch(toolareaActions.pollSubmitList(id, data)),
	toggleToolArea : () => { dispatch(toolareaActions.closeToolArea()); }
});

export default withRoomContext(connect(
	// mapStateToProps,
	makeMapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.me === next.me &&
				prev.settings === next.settings &&
				prev.toolarea.pollingTab === next.toolarea.pollingTab &&
				prev.toolarea.currentResultPollObj === next.toolarea.currentResultPollObj &&
				prev.toolarea.peersPollSubmitObj === next.toolarea.peersPollSubmitObj&&
				prev.toolarea.toggleToolArea === next.toolarea.toggleToolArea &&
				prev.webinar.webinarData === next.webinar.webinarData

			);
		}
	}
)(withStyles(styles)(PollsResult)));